import { render, staticRenderFns } from "./dossier-soins.html?vue&type=template&id=7d6dac7c&scoped=true&external"
import script from "./dossier-soins.js?vue&type=script&lang=js&external"
export * from "./dossier-soins.js?vue&type=script&lang=js&external"
import style0 from "./dossier-soins.scss?vue&type=style&index=0&id=7d6dac7c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6dac7c",
  null
  
)

export default component.exports